var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotConnectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.175 1.40845L0 2.58345L0.833333 3.40845V13.3334C0.833333 14.2501 1.575 15.0001 2.49167 15.0001H8.33333V16.6668H6.66667V18.3334H13.3333V16.6668H11.6667V15.0001H12.4167L17.4167 20.0001L18.5917 18.8251L1.175 1.40845ZM2.49167 13.3334V5.07511L10.75 13.3334H2.49167ZM3.79167 1.66678L5.45833 3.33345H17.5V13.3334H15.4583L17.125 15.0001H17.4917C18.4083 15.0001 19.1583 14.2501 19.1583 13.3334V3.33345C19.1583 2.41678 18.4083 1.66678 17.4917 1.66678H3.79167Z",
    fill: "#FF4747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotConnectedIcon);
export default __webpack_public_path__ + "static/media/not-connected-icon.0514631bfb0428d806f892f3b9bc9039.svg";
export { ForwardRef as ReactComponent };